var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NcContent,{attrs:{"app-name":"settings"}},[_c('router-view',{attrs:{"name":"navigation"}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('router-view',{attrs:{"name":"sidebar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }